import { Reveal, Eyebrow, Btn } from "./Bits";

export const PageHero = ({ eyebrow, title, subtitle, copy, image, ctas, tone = "light" }) => (
  <section
    data-testid="page-hero"
    className={tone === "dark" ? "bg-[#111111]" : "border-b border-[#111111]/10 bg-white"}
  >
    <div className={tone === "dark" ? "mako-grid-bg-dark" : "mako-grid-bg"}>
      <div className="mx-auto grid max-w-[1400px] items-center gap-12 px-6 py-16 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:py-24">
        <Reveal className={image ? "lg:col-span-6" : "lg:col-span-9"}>
          {eyebrow && <Eyebrow tone={tone === "dark" ? "light" : "dark"}>{eyebrow}</Eyebrow>}
          <h1
            className={`mt-7 font-display text-3xl font-bold uppercase leading-[1] tracking-[-0.02em] sm:text-4xl lg:text-[3.5rem] ${
              tone === "dark" ? "text-white" : "text-[#111111]"
            }`}
          >
            {title}
            {subtitle && (
              <span className={`mt-2 block ${tone === "dark" ? "text-[#8AB4DA]" : "text-[#7A7F85]"}`}>
                {subtitle}
              </span>
            )}
          </h1>
          {copy && (
            <p
              className={`mt-8 max-w-2xl text-sm leading-relaxed sm:text-base ${
                tone === "dark" ? "text-white/70" : "text-[#3B3B3B]"
              }`}
            >
              {copy}
            </p>
          )}
          {ctas && (
            <div className="mt-11 flex flex-col gap-3 sm:flex-row">
              {ctas.map((c) => (
                <Btn key={c.label} to={c.to} href={c.href} variant={c.variant} data-testid={c.testId}>
                  {c.label}
                </Btn>
              ))}
            </div>
          )}
        </Reveal>

        {image && (
          <Reveal delay={0.12} className="lg:col-span-6">
            <div className="relative aspect-[5/4] overflow-hidden bg-[#F5F5F2]">
              <img src={image} alt={title} className="h-full w-full object-cover" />
              <div className="absolute inset-x-0 bottom-0 h-[3px] bg-[#0F4C81]" />
            </div>
          </Reveal>
        )}
      </div>
    </div>
  </section>
);
